import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectCurrentUser } from "../features/auth/authSlice";
import { moduleRoutes } from "./moduleRoutes";
import RoleBasedRoute from "./RoleBasedRoute";
import AppLayout from "../components/layout/AppLayout";
import LoginPage from "../pages/auth/LoginPage";
import ForceChangePasswordPage from "../pages/auth/ForceChangePasswordPage";
import NotFoundPage from "../pages/auth/NotFoundPage";
import ForbiddenPage from "../pages/auth/ForbiddenPage";
import LoadingSpinner from "../components/common/LoadingSpinner";

function PrivateRoutes() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUser = useSelector(selectCurrentUser);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // first login with the system-generated password: choose a new one before anything else
  if (currentUser?.must_change_password) {
    return <Navigate to="/set-new-password" replace />;
  }
  return (
    <AppLayout>
      <Suspense fallback={<LoadingSpinner fullPage />}>
        <Routes>
          {moduleRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <RoleBasedRoute
                  module={route.module}
                  requiredPermission={route.requiredPermission || "can_view"}
                >
                  {route.element}
                </RoleBasedRoute>
              }
            />
          ))}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </AppLayout>
  );
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/set-new-password" element={<ForceChangePasswordPage />} />
        <Route path="/*" element={<PrivateRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}
